/**
 * 
 * Pages using this template: 
 *  1) MediaPage
 *  2) NewsPage
 *  3) PrivacyPage
 * 
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as prismicActions from '../redux/actions/prismicActions';
import MetaTags from '../components/MetaTags';
import ComingSection from '../components/GeneralPage/ComingSection';
import GeneralSection from '../components/GeneralPage/GeneralSection';
import LoadingOverlay from '../components/LoadingOverlay';
// import { Link } from 'react-router-dom';
// import PrismicReact from 'prismic-reactjs';

const propTypes = {
  enUID: PropTypes.string.isRequired,
  frUID: PropTypes.string.isRequired,
}

class GeneralPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      doc: null,
      notFound: false,
    }
  }

  componentWillMount() {
    this.findPage(this.props)
  }

  componentWillReceiveProps(props) {
    this.findPage(props)
  }

  findPage(props) {
    if(props.prismicData) {
      let doc = props.prismicData.results.find(result => result.type === 'general_page' && (result.uid === props.enUID || result.uid === props.frUID)) 

      this.setState({doc})
      props.getActiveDoc(doc)
    }
  }

  render() {
    if(this.state.doc) {
      let {
        prismicCtx
      } = this.props
      const document = this.state.doc
      const docData = document.data
      // console.log(document)
      return (
        <main data-wio-id={document.id} id={document.id} className={`page page-${document.id}`}>
          <MetaTags 
            title={`${docData.meta_title ? docData.meta_title : 'AltaVie'}`}
            description={`${docData.meta_description ? docData.meta_description : "Open your mind and find your state of mindfulness, enhanced by our low THC, high CBD strains of cannabis. At AltaVie, we're all about elevating the way you live."}`}
          />
          {/* {
            document.uid === 'declaration-de-confidentialite' || document.uid === 'privacy-policy' || document.uid === '404-error' || document.uid === '404-erreur'? 
            null
            :
            <AgeGate/>
          } */}
          {
            document.data.body.map((slice, index) => {
              if(slice.slice_type === 'coming_soon_section') {
                return (
                  <ComingSection
                    key={index}
                    slice={slice}
                    linkResolver={prismicCtx.linkResolver}
                  />
                )
              } else if(slice.slice_type === 'general_content_section') {
                return (
                  <GeneralSection
                    key={index}
                    slice={slice}
                    linkResolver={prismicCtx.linkResolver}
                  />
                )
              }
            })
          }
        </main>
      )
    } 
    return <LoadingOverlay/>
  }
}

const mapStateToProps = state => ({
  locale: state.global.locale,
  activeDoc: state.prismic.activeDoc,
  prismicCtx: state.prismic.prismicCtx,
  prismicData: state.prismic.prismicData,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { getActiveDoc: prismicActions.getActiveDoc, },
    dispatch
  )

GeneralPage.propTypes = propTypes

export default connect(mapStateToProps, mapDispatchToProps)(GeneralPage)


// WEBPACK FOOTER //
// ./src/pages/GeneralPage.js